<template>
  <SettlementCarReadinessCard
    :status="status"
    :status-color="statusColor"
    :completed="carReadinessDone"
    :dealer-name="settlement.dealer.name"
    :date="settlement.confirmedDelivery"
    :delivery-message="settlement.deliveryMessage"
    :is-mobile="$q.screen.xs"
    v-bind="$attrs"
  />
</template>

<script>
import sendSettlementEvent from '../../utils/send-settlement-event';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'SettlementCarReadinessStep',
  computed: {
    ...mapState({
      settlement: (state) => state.settlement.settlement
    }),
    ...mapGetters('settlement', ['carReadinessDone']),
    status() {
      return this.carReadinessDone ? 'Completed' : 'Pending';
    },
    statusColor() {
      return this.carReadinessDone ? 'positive' : 'warning';
    }
  },
  mounted() {
    sendSettlementEvent({
      label: `car-readiness-${this.status.toLowerCase()}`
    });
  },
  components: {
    SettlementCarReadinessCard: () =>
      import('../../components/molecule/settlement-car-readiness-card')
  }
};
</script>
